import {z} from 'zod';
import {NodeType} from 'common/src/modules/nodes/nodes.types';
import {CreativeNodeData} from 'common/src/modules/creatives/creatives.types';
import {LandingPageSource} from 'common/src/modules/campaigns/campaigns.enums';
import {DTCreativeNode} from 'common/src/modules/decisionTree/decisionTree.types';
import {creativeCardSchema} from '../../../../../schemas/creativeCardSchema';
import {getAICardBaseDetails} from '../../utils/getAICardBaseDetails';

export function convertCreativeAICardToAPICard(creativeCard: z.input<typeof creativeCardSchema>) {
  return {
    ...getAICardBaseDetails(creativeCard),
    type: NodeType.CREATIVE,
    ...(creativeCard.creativeId > 0 ? {creativeId: creativeCard.creativeId} : {}),
    landingPageSource: creativeCard.landingPageSource ?? LandingPageSource.Campaign,
    creative: undefined as unknown as CreativeNodeData,
    isFallbackCreative: creativeCard.isFallback,
  } as Omit<DTCreativeNode, 'outputs' | 'inputs'>;
}
